import apiFetch from '../apiFetch'

export default function (idAgenda, leido, token) {
  return apiFetch({endPoint: `Agenda/marcarNotificacionLeida?idAgenda=` + idAgenda + `&leido=` + leido, method: 'GET', body: null, token: token})
}